import { Icon } from '@iconify/react/dist/iconify.js'
import React, { useEffect, useState } from 'react'
import { addNewCategory } from '../../apiHelper/authService'
import toast from 'react-hot-toast'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { clearSelectedCategory } from '../../redux/authModalSlice'
import { useDispatch } from 'react-redux'
const AddNewCategory = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    let { user } = useSelector(state => state.authModal)
    const { selectedCategory } = useSelector((state) => state.authModal);
    const [mailImage, setMailImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);

    //   const quillRef = useRef();
    const [imageName, setImageName] = useState('');
    const [categoryName, setCategoryName] = useState('');
    const [categoryId, setCategoryId] = useState('');

    const [isPublished, setIsPublished] = useState(false);

    // const { user } = useSelector((state) => state.authModal);
    const [categories, setCategories] = useState();


    const fromCountry = user?.from;
    const toCountry = user?.to;




    const [loading, setLoading] = useState(false)


    const handleAddNewCategory = async () => {



        if (!categoryName) {
            toast.error("Enter category name first")
            return;
        }


        if (!imagePreview) {
            toast.error("Image is required");
            return;
        }
        setLoading(true);


        const formData = new FormData();
        formData.append('isActive', isPublished);
        formData.append('id', categoryId);
        formData.append('from', fromCountry);
        formData.append('to', toCountry);
        formData.append('name', categoryName);



        if (mailImage) {
            formData.append('categoryImage', mailImage);
        }









        const toastId = toast.loading("Creating Category...");

        try {
            const data = await addNewCategory(formData);
            // setCategories(data);
            toast.success("Category created successfully!", { id: toastId });
            navigate("/categories")

        } catch (err) {
            console.error("Fetch Error:", err);

            toast.error(
                err || "Something went wrong while creating category.",
                { id: toastId }
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (selectedCategory) {
            setCategoryName(selectedCategory.name || '');
            setIsPublished(selectedCategory.isActive || false);
            setCategoryId(selectedCategory?.id || '')


            if (selectedCategory?.image_url) {
                setImagePreview(selectedCategory.image_url);
                const imageName = selectedCategory.image_url
                setImageName(imageName);
                setMailImage(selectedCategory?.image_url)
            } else {
                setImagePreview(null);
                setImageName('');
                setMailImage('')
            }


        }

        return () => {
            // Clear Redux state when navigating away
            dispatch(clearSelectedCategory());
        };
    }, [selectedCategory, dispatch]);


    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith('image/')) {
            setMailImage(file);

            setImagePreview(URL.createObjectURL(file));
            setImageName(file.name);
        } else {
            alert('Please upload a valid image file');
        }
    };

    const handleRemoveImage = () => {
        setMailImage(null);

        setImagePreview(null);
        setImageName('');
    };


    return (
        <div className="col-md-12 ">
            <div className="card">
                <div className="card-header">
                    <h5 className="card-title mb-0">Add New Category</h5>
                </div>
                <div className="card-body">
                    <div className="row gy-4">
                        <div className="col-12 col-md-6">
                            <label className="form-label fw-bold text-neutral-900">Category Name</label>
                            <div className="icon-field">
                                <span className="icon">
                                    <Icon icon="mdi:shape-outline" />
                                </span>
                                <input
                                    type="text"
                                    name="categoryName"
                                    value={categoryName}
                                    onChange={(e) => setCategoryName(e.target.value)}
                                    className="form-control"
                                    placeholder="Enter Category Name"
                                />
                            </div>
                        </div>


                        <div className="col-12">

                            <div className="form-switch switch-primary d-flex align-items-center gap-3">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="horizontal1"
                                    checked={isPublished}
                                    onChange={(e) => setIsPublished(e.target.checked)}
                                />

                                <label
                                    className="form-check-label line-height-1 fw-medium text-secondary-light"
                                    htmlFor="horizontal1"
                                >
                                    Publish
                                </label>
                            </div>
                        </div>






                        <div className="col-12 col-md-6">
                            <label className='form-label fw-bold text-neutral-900'>
                                Category Image
                            </label>
                            <div className='upload-image-wrapper'>
                                {imagePreview ? (
                                    <div className='uploaded-msg-wrapper h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-success-50 d-flex justify-content-between align-items-center px-3'>
                                        <div>
                                            <p className='mb-1 fw-semibold text-success-700'>Image uploaded successfully</p>
                                            <p className='mb-0 text-sm text-neutral-700'>{imageName}</p>
                                        </div>
                                        <button
                                            type='button'
                                            className='btn btn-sm btn-danger ms-3'
                                            onClick={handleRemoveImage}
                                        >
                                            Remove
                                        </button>
                                    </div>
                                ) : (
                                    <label
                                        className='upload-file h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50 bg-hover-neutral-200 d-flex align-items-center flex-column justify-content-center gap-1 cursor-pointer'
                                        htmlFor='upload-file'
                                    >
                                        <iconify-icon
                                            icon='solar:camera-outline'
                                            className='text-xl text-secondary-light'
                                        ></iconify-icon>
                                        <span className='fw-semibold text-secondary-light'>
                                            Upload
                                        </span>
                                        <input
                                            id='upload-file'
                                            type='file'
                                            hidden
                                            accept='image/*'
                                            onChange={handleFileChange}
                                        />
                                    </label>
                                )}
                            </div>
                        </div>






                        <div className="col-12">
                            <button onClick={handleAddNewCategory} className="btn btn-primary-600">
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddNewCategory